import { $t } from '@/i18n';
export default {
  type: 'object',
  fields: [
    {
      id: 'attr',
      title: $t('k_6de62429'),
      type: 'string',
      'uc:allowExpr': false,
      'uc:allowReset': false,
      group: $t('k_6de62429'),
      ui: { type: 'PageletAttr' },
    },
    { id: 'className', type: 'string' },
  ],
};
